(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDialogController', PackageFeatureListDialogController);

    PackageFeatureListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PackageFeatureList', 'CompanyCustom'];

    function PackageFeatureListDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PackageFeatureList, CompanyCustom) {
        var vm = this;

        vm.packageFeatureList = entity;
        vm.clear = clear;
        vm.save = save;
        vm.searchCompany = searchCompany;
        vm.companyKeyUrl = "";
        vm.company = {};


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.company.id)
                vm.packageFeatureList.company = vm.company;

            if (vm.packageFeatureList.id !== null) {
                PackageFeatureList.update(vm.packageFeatureList, onSaveSuccess, onSaveError);
            } else {
                PackageFeatureList.save(vm.packageFeatureList, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:packageFeatureListUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function searchCompany() {
            if (!vm.packageFeatureList.companyId && vm.companyKeyUrl != "") {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.company = result;

                    }
                })
            }
        }

    }
})();
